// frontend/src/services/instagramService.js
import axios from "axios";

// Configurar URL base según el entorno
const BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/api/content', '')
  : 'http://localhost:8000';

// Crear instancia de axios para Instagram
const instagramApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const instagramService = {
  businessDiscovery(username, fields) {
    const FIELDS =
      fields ||
      "id,username,name,biography,profile_picture_url,website,followers_count,follows_count,media_count";
    return instagramApi.get("/instagram/instagram/discovery/", {
      params: { username, fields: FIELDS },
    });
  },

  /**
   * Obtener comentarios de los posts recientes de Instagram
   * @param {string} instagramId - ID de la cuenta de Instagram
   * @param {number} limitPosts - Número de posts recientes a analizar (default: 25)
   * @param {number} limitCommentsPerPost - Comentarios máximos por post (default: 50)
   * @param {boolean} analyze - Si se debe analizar el sentimiento (default: false)
   * @param {string} dateFrom - Fecha inicial (YYYY-MM-DD) (optional)
   * @param {string} dateTo - Fecha final (YYYY-MM-DD) (optional)
   */
  getComments(instagramId, limitPosts = 25, limitCommentsPerPost = 50, analyze = false, dateFrom = '', dateTo = '') {
    const params = {
      instagram_id: instagramId,
      limit_posts: limitPosts,
      limit_comments_per_post: limitCommentsPerPost,
      analyze: analyze
    };

    // Solo agregar fechas si están definidas
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;

    return instagramApi.get("/instagram/api/comments/", { params });
  },

  /**
   * Analizar sentimiento de comentarios ya guardados
   * @param {string} instagramId - ID de la cuenta de Instagram (optional)
   * @param {string} postId - ID del post específico (optional)
   * @param {number} days - Número de días hacia atrás para analizar (default: 30)
   */
  analyzeSentiment(instagramId = null, postId = null, days = 30) {
    return instagramApi.post("/instagram/api/comments/sentiment/", {
      instagram_id: instagramId,
      post_id: postId,
      days: days
    });
  },

  /**
   * Obtener todas las cuentas de Instagram conectadas
   */
  getAccounts() {
    return instagramApi.get("/instagram/api/accounts/");
  },
};

export default instagramService;
